import { render, staticRenderFns } from "./TourReportManagerInfo.vue?vue&type=template&id=52f67791"
import script from "./TourReportManagerInfo.vue?vue&type=script&lang=js"
export * from "./TourReportManagerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports